export interface BulkSelectionNode {
  id: number;
  type: string | undefined;
  wifi_enabled: 0 | 1 | null | undefined;
  commtrac_ack?: '0' | '1' | null;
  commtrac_external_id?: number | null;
  atest?: '0' | '1' | null;
  mc2_flag?: 0 | 1 | null;
  has_motion_sensor?: 0 | 1 | null;
  cam_monitor_battery?: number | null;
}

export type CommtracSubtype =
  | 'WiFi'
  | 'MC'
  | 'MC2'
  | 'TAG'
  | 'CAM'
  | 'AT'
  | undefined;

export const FREQUENCY_MIN = 1;
export const FREQUENCY_MAX = 1000;

export const isQualifyingMiner = (node: BulkSelectionNode): boolean => {
  if (node.type !== 'miner') {
    return false;
  }
  if (node.wifi_enabled) {
    return false;
  }
  if (node.commtrac_ack !== '1') {
    return false;
  }
  return true;
};

export const supportsBatteryMonitoring = (
  node: BulkSelectionNode,
  subtype: CommtracSubtype
): boolean => {
  return isQualifyingMiner(node) && subtype === 'CAM';
};

export const supportsTrackMotion = (node: BulkSelectionNode): boolean => {
  return isQualifyingMiner(node);
};

export const supportsBroadcastFrequency = (
  node: BulkSelectionNode
): boolean => {
  return isQualifyingMiner(node);
};

export const allMatch = <T>(items: T[], predicate: (item: T) => boolean) => {
  if (items.length === 0) {
    return false;
  }
  return items.every(predicate);
};
